export default __webpack_public_path__ + "static/media/orbisTransparent.f8a3fa2f.png";